import React, {useEffect, useState} from 'react';

function useMessage() {
  const [message, setMessage] = useState<any>({});

  useEffect(() => {
    if (!('EventSource' in window)) {
      return;
    }
    const url = `${process.env.GATSBY_BASE_URL}/stream`;
    console.log('stream url', url);
    const sse = new EventSource(url, {
      withCredentials: true,
    });

    sse.addEventListener('payments', env => {
      // console.log('event', env);
      setMessage({...message, payments: JSON.parse(env?.data ?? '{}')});
    });

    sse.onmessage = msg => {
      console.log('new message', msg);
      setMessage({...message, message: JSON.parse(msg?.data ?? '{}')});
    };

    sse.onerror = e => {
      console.error(e);
      sse.close();
    };
    sse.onopen = msg => {
      console.log('sse set connected!', msg);
    };

    return () => {
      sse.close();
    };
  }, []);

  return {message};
}

type SSEMessageType = {
  message: any;
};

type SSEProps = {
  children: React.ReactNode;
};

const SSEContext = React.createContext<SSEMessageType>({
  message: '',
});

export const SSEProvider = ({children}: SSEProps) => {
  const message = useMessage();
  return <SSEContext.Provider value={message}>{children}</SSEContext.Provider>;
};

export const useSSE = () => React.useContext<SSEMessageType>(SSEContext);
